module.exports = __webpack_public_path__ + "static/fonts/iconfont.9a8d1b2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/iconfont.ttf
// module id = gjvD
// module chunks = 1